// extracted by mini-css-extract-plugin
export var carrierInformation = "N0s0F8XXkjHDITTqGz0V";
export var subHeaderRow = "o5fGQu7kXES6QseII6Jf";